import React, { useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import apiService from '../services/ApiService'

function UltimasNoticias() {
  const [posts, setPosts] = useState([])

  const processImages = (imagesData) => {
    if (!imagesData) return []
    try {
      if (typeof imagesData === 'object' && !Array.isArray(imagesData)) return Object.values(imagesData)
      if (Array.isArray(imagesData)) return imagesData
      return Object.values(JSON.parse(imagesData))
    } catch {
      return []
    }
  }

  useEffect(() => {
    const fetchPosts = async () => {
      const websiteId = Number.parseInt(process.env.REACT_APP_WEBSITE_ID, 10)
      const fetchedPosts = await apiService.getPosts(websiteId)
      if (!fetchedPosts) return
      const processed = fetchedPosts
        .filter(post => post.status === 'published')
        .map(post => ({ ...post, images: processImages(post.images) }))
      setPosts(processed.slice(0, 4))
    }
    fetchPosts()
  }, [])

  return (
    <Row className="mt-3">
      <Col xs={12}>
        <h2 className="section-title">Últimas Notícias</h2>
      </Col>
      {posts.map((post) => {
        const coverImage = post.images.find(img => img.cover)
        const excerpt = post.text ? post.text.replaceAll(/<[^>]*>/gu, '').slice(0, 110) : ''
        const category = post.category || post.categories?.[0]?.name || null

        return (
          <Col xs={12} sm={6} md={3} key={post.id} className="mb-4">
            <Link to={`/noticias/${post.slug}`} className="news-card-link">
              <div className="news-card-new">
                {/* Imagem com badge */}
                <div className="news-card-image-wrapper">
                  {coverImage ? (
                    <img
                      src={`${process.env.REACT_APP_CDN}/${process.env.REACT_APP_IMAGE_BUCKET}/${coverImage.name}`}
                      alt={post.title}
                      className="news-card-image"
                    />
                  ) : (
                    <div className="news-card-image-placeholder" />
                  )}
                  {category && (
                    <span className="news-card-badge">{category}</span>
                  )}
                </div>
                {/* Texto */}
                <div className="news-card-body">
                  <h6 className="news-card-title">{post.title}</h6>
                  {excerpt && (
                    <p className="news-card-excerpt">{excerpt}{post.text?.length > 110 ? '…' : ''}</p>
                  )}
                </div>
              </div>
            </Link>
          </Col>
        )
      })}
    </Row>
  )
}

export default UltimasNoticias
